// Simple encryption for redacted text
const REDACTION_KEY = 'redaction-simple-key';

export const encryptRedactedText = (text: string): string => {
  let encrypted = '';
  for (let i = 0; i < text.length; i++) {
    const charCode = text.charCodeAt(i) ^ REDACTION_KEY.charCodeAt(i % REDACTION_KEY.length);
    encrypted += String.fromCharCode(charCode);
  }
  // Use encodeURIComponent to handle Unicode characters safely before base64 encoding
  return btoa(encodeURIComponent(encrypted));
};

export const decryptRedactedText = (encryptedText: string): string => {
  try {
    const decoded = atob(encryptedText); // Base64 decode
    const unescaped = decodeURIComponent(decoded); // Decode URI component
    let decrypted = '';
    for (let i = 0; i < unescaped.length; i++) {
      const charCode = unescaped.charCodeAt(i) ^ REDACTION_KEY.charCodeAt(i % REDACTION_KEY.length);
      decrypted += String.fromCharCode(charCode);
    }
    return decrypted;
  } catch (error) {
    console.error('Failed to decrypt redacted text:', error);
    return '';
  }
};
